import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddGuest from "../components/AddGuestLayer";


const AddGuestPage = () => {
  return (
    <>
      
        {/* Breadcrumb */}
        <Breadcrumb title="Add Guest" />

        {/* AddUserLayer */}
        <AddGuest />
   
    </>
  );
};

export default AddGuestPage;
